// Support request form for a Checkout Sessions buyer who can't be routed anywhere else with
// confidence. It never re-enters checkout, so it can't charge the buyer again.
export const SUPPORT_URL = 'https://support.calm.com/hc/en-us/requests/new';
